module.exports = __webpack_public_path__ + "static/media/18.893d8700.mp3";